export const isBlobObjectUrl = (url: string): boolean => url.startsWith('blob:');

export const revokeBlobObjectUrls = (urls: Iterable<string>): void => {
  for (const url of urls) {
    if (isBlobObjectUrl(url)) {
      URL.revokeObjectURL(url);
    }
  }
};
